/**
 * @fileoverview Utilitários de status de pasta.
 *
 * Fornece funções para determinar e exibir o status de pastas,
 * baseado na última transação (recebido, não recebido, recusado).
 *
 * Usado em listagens e cards de pasta para exibir badges de status.
 *
 * @module mixins/folder-status
 * @see {@link module:typedef~Folder} para definição de Folder
 * @see {@link module:typedef~Transaction} para definição de Transaction
 */

/**
 * Labels para tipos de pendência.
 * @constant {Object}
 */
export const FOLDER_PENDING_TYPE_LABEL = {
    signature: 'Assinatura',
    review: 'Revisão',
}

/*export const folderStatusIconMap = new Map([
    ['Recebido', 'mdi-check'],
    ['Não Recebido', 'mdi-clock-outline'],
    ['Recusado', 'mdi-close'],
    ['Pendente', 'mdi-clock-outline'],
    ['Assinado', 'mdi-check'],
    ['Revisado', 'mdi-eye'],
])

export const getFolderStatusIcon = (folder) => {

}*/

/**
 * Obtém a última transação de uma pasta.
 * @returns {Transaction|null}
 */
export const getFolderLastTransaction = (folder) => {
    if (folder.last_transaction) return folder.last_transaction;

    if (folder.transactions && folder.transactions.length > 0)
        return folder.transactions.find((transaction) => transaction.last_transaction === true) || folder.transactions[0];

    return null;
}

export const getFolderStatus = (folder) => {
    if (folder.last_transaction) return getTransactionStatus(folder.last_transaction);

    return 'Não Recebido';
}

export const getTransactionStatus = (transaction) => {
    if (transaction.received) return 'Recebido';

    if (!transaction.transaction_state || transaction.transaction_state.enum === 'transact') return 'Não Recebido';

    if (transaction.transaction_state.name) return transaction.transaction_state.name;

    return 'Não Recebido';
}

export const getFolderPendingTypeLabel = (folder) => {
    if (!folder.pending_type) return 'Pendente';

    return FOLDER_PENDING_TYPE_LABEL[folder.pending_type];
}

/**
 * @param folder
 * @returns {'Recebido' | 'Não Recebido' | 'Recusado' | string}
 */
export const getFolderStatusLabel = (folder) => {
    if (folder.received_status) return folder.received_status;

    if (folder.last_transaction) return getTransactionStatus(folder.last_transaction);

   return 'Não Recebido';
}

export const isFolderPending = (folder) => getFolderStatusLabel(folder) === 'Não Recebido';

export const isFolderReceived = (folder) => getFolderStatusLabel(folder) === 'Recebido';

export const isFolderRejected = (folder) => getFolderStatusLabel(folder) === 'Recusado';


/**
 * Métodos para manipulação de status de pastas
 */
export const mapFolderMethods = {
    getFolderStatus,
    getTransactionStatus,
    getFolderStatusLabel,
    getFolderPendingTypeLabel,
    isFolderPending,
    isFolderReceived,
    isFolderRejected,
}



// WEBPACK FOOTER //
// ./src/mixins/folder-status.js